import { Flex, Box, BoxProps, HStack } from '@chakra-ui/react'
import * as React from 'react'

import { LogoNipponPaint, LogoPaintWonder } from '../icons'
import { useResponsive } from '../../hooks/useResponsive'
import ButtonSoundS from '../buttons/ButtonSoundS'
import Link from '../common/Link'
import SVG from '../common/SVG'
import usePageColor from '../../hooks/usePageColor'

export type FooterProps = BoxProps & {}

const Footer: React.FC<FooterProps> = ({ ...others }) => {
  const color = usePageColor()
  const isPC = useResponsive(false, true)
  return (
    <>
      {isPC && (
        <Box
          pos="fixed"
          boxSizing="border-box"
          w="100%"
          left="0px"
          right="0px"
          bottom="0px"
          fontSize="10px"
          color={color}
          {...others}
        >
          <Flex justifyContent="space-between" m="20px 30px">
            <HStack spacing="30px">
              <ButtonSoundS color={color} />
              <Link to="mailto:ayda@kenchiku.co.jp">お問い合わせ</Link>
              <Link to="/privacypolicy/">プライバシーポリシー</Link>
              <Link to="/snspolicy/">ソーシャルメディアポリシー</Link>
            </HStack>
            <HStack spacing="20px">
              <SVG svg={<LogoPaintWonder />} w="100px" />
              <Link to="https://www.nipponpaint-holdings.com/">
                <SVG svg={<LogoNipponPaint />} w="192px" />
              </Link>
            </HStack>
          </Flex>
        </Box>
      )}
    </>
  )
}

export default Footer
